<script setup>
  import { ref, onMounted } from 'vue';
  import { useSpotStore } from "@/stores/SpotStore";
  import { useAlertStore } from "@/stores/AlertStore";
  import useLegacyBridge from "@/composables/useLegacyBridge";
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const { $WEB_VIEW } = useSettingsGlobals();   

  const props = defineProps({
    advisoryId: {
      type: [String, Number],
      required: false
    }
  })

  const model = defineModel();

  const spotStore = useSpotStore();
  const alertStore = useAlertStore();

  const { advisories } = useLegacyBridge();

  const contentContainer = ref(null);
  
  function loadAdvisories() {
    const settings = {
        lat: spotStore.lat,
        lon: spotStore.lon,
        spotId: spotStore.spotId,
        timezoneName: spotStore.localTimezone,
        modalMap: !$WEB_VIEW,
        advisoriesData: [...alertStore.alerts]
    }       
    
    model.value = advisories(contentContainer.value, settings);

    if (props.advisoryId) openAdvisoryModal(props.advisoryId);
  }

  function openAdvisoryModal(id) {
    const advisoryButton = contentContainer.value.querySelector(`[data-bulletin-id="${id}"]`);

    if (!advisoryButton) return;

    advisoryButton.click();
  }

  onMounted(() => loadAdvisories());
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>